module.exports = __webpack_public_path__ + "images/the-favorite-b061741a52aafc74b333cdbce5e31765.png";